import "./SocialSection.css";

const SocialSection = ({ data }: { data: any }) => {
  return (
    <section className="social-section">
      <div className="social-left">
        <div className="social-heading">
          <img
            src={data?.linkedin?.logo}
            alt={data?.linkedin?.platformName}
            className="icon"
          />
          <h2>{data?.linkedin?.platformName}</h2>
        </div>
        <div className="computer-container">
          <img
            src={data?.linkedin?.computerImage}
            alt="Computer"
            className="computer-img"
          />
          <img
            src={data?.linkedin?.screenImage}
            alt="Screen"
            className="screen-img"
          />
        </div>

        <a
          href={data?.linkedin?.link}
          target="_blank"
          rel="noopener noreferrer"
          className="connect-button"
        >
          Connect Now
        </a>
      </div>
      <div className="social-right">
        <div className="social-heading">
          <img
            src="/images/social/InstagramLogo.jpg"
            alt="Instagram Icon"
            className="icon"
          />
          <h2>{data?.instagram?.platformName}</h2>
        </div>

        <div className="insta-grid">
          {data?.instagram?.images?.map((img: any, index: number) => (
            <div className="insta-grid-item" key={index}>
              <img src={img} alt="Insta" />
            </div>
          ))}
        </div>

        <a
          href={data?.instagram?.link}
          target="_blank"
          rel="noopener noreferrer"
          className="connect-button"
        >
          Connect Now
        </a>
      </div>
    </section>
  );
};

export default SocialSection;
